module.exports = __webpack_public_path__ + "img/4064015550.0ed8c6fe.jpg";